// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"styles_termsContainer__2kogJ","showTerms":"styles_showTerms__3gkG4","hideTerms":"styles_hideTerms__3LJpv"};